import React, { useState, useEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import FilterDropdown from './filters/FilterDropdown';
import { SECTORS } from '../../constants/authConstants';
import { departmentService } from '../../services/departmentService';
import { financialYearUtils } from '../../utils/helpers';

const UniversalFilters = ({ 
  config, 
  values, 
  onChange, 
  onClearFilters,
  mode = 'dropdown',
  dropdownProps = {},
  className = ''
}) => {
  const { isMobile } = useTheme();
  const [departments, setDepartments] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(false);

  useEffect(() => {
    const needsDepartments = config.some(filter => filter.type === 'department');
    if (needsDepartments) {
      loadDepartments();
    }
  }, [config]);

  const loadDepartments = async () => {
    try {
      setLoadingDepartments(true);
      const allDepartments = await departmentService.getActiveDepartments();
      setDepartments(allDepartments);
    } catch (error) {
      console.error('Error loading departments:', error);
      setDepartments([]);
    } finally {
      setLoadingDepartments(false);
    }
  };

  // Separate financialYear filter from other filters
  const financialYearFilter = config.find(filter => filter.type === 'financialYear');
  const otherFilters = config.filter(filter => filter.type !== 'financialYear');

  const enhancedConfig = otherFilters.map(filter => {
    if (filter.type === 'department') {
      const sortedDepartments = [...departments].sort((a, b) => 
        (a.priority || 999) - (b.priority || 999)
      );
      
      return {
        ...filter,
        options: sortedDepartments.map(dept => ({
          value: dept.departmentCode,
          label: dept.departmentName
        })),
        disabled: filter.disabled || loadingDepartments
      };
    }
    
    if (filter.type === 'sector') {
      return {
        ...filter,
        options: SECTORS
      };
    }
    
    return filter;
  });

  if (mode === 'dropdown') {
    return (
      <div className={`flex items-center space-x-3 ${className}`}>
        {/* Financial Year Filter - Always Visible Outside Dropdown */}
        {financialYearFilter && (
          <select
            value={values[financialYearFilter.key] || ''}
            onChange={(e) => onChange(financialYearFilter.key, e.target.value)}
            disabled={financialYearFilter.disabled}
            className="border border-gray-300 rounded-lg bg-white
              focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
              text-gray-700 appearance-none cursor-pointer font-medium
              transition-all duration-200 px-4 py-2 text-sm
              disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-100
              hover:bg-gray-50"
            title={financialYearFilter.label || 'Financial Year'}
          >
            <option value="">{financialYearFilter.placeholder || 'Select Financial Year'}</option>
            {financialYearUtils.getFinancialYearOptions().map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        )}

        {/* Other Filters in Dropdown */}
        {otherFilters.length > 0 && (
          <FilterDropdown
            config={enhancedConfig}
            values={values}
            onChange={onChange}
            onClearFilters={onClearFilters}
            {...dropdownProps}
          />
        )}
      </div>
    );
  }

  return null;
};

export default UniversalFilters;